var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 219,
    viewBox: "0 0 219 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 0C14.0137 0 0 14.0137 0 31.25V187.5C0 204.736 14.0137 218.75 31.25 218.75H187.5C204.736 218.75 218.75 204.736 218.75 187.5V68.9941C218.75 60.6934 215.479 52.7344 209.619 46.875L171.875 9.13086C166.016 3.27148 158.057 0 149.756 0H31.25ZM31.25 46.875C31.25 38.2324 38.2324 31.25 46.875 31.25H140.625C149.268 31.25 156.25 38.2324 156.25 46.875V78.125C156.25 86.7676 149.268 93.75 140.625 93.75H46.875C38.2324 93.75 31.25 86.7676 31.25 78.125V46.875ZM109.375 125C117.663 125 125.612 128.292 131.472 134.153C137.333 140.013 140.625 147.962 140.625 156.25C140.625 164.538 137.333 172.487 131.472 178.347C125.612 184.208 117.663 187.5 109.375 187.5C101.087 187.5 93.1384 184.208 87.2779 178.347C81.4174 172.487 78.125 164.538 78.125 156.25C78.125 147.962 81.4174 140.013 87.2779 134.153C93.1384 128.292 101.087 125 109.375 125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsave);
export default __webpack_public_path__ + "static/media/isave.5797df67a65f8450fda9d17bbf6db9a7.svg";
export { ForwardRef as ReactComponent };